import React from 'react';
import styled, { withTheme } from 'styled-components';
import { FormattedMessage } from 'react-intl';

const NoDataContainer = styled.div`
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
`;

const NoData = () => (
  <NoDataContainer>
    <FormattedMessage id="Data.NoData" />
  </NoDataContainer>
);

export default withTheme(NoData);
